"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.videoFileTypes = exports.uploadableImageFileTypes = exports.textFileTypes = exports.fontFileTypes = exports.domMountableImageFileTypes = exports.documentFileTypes = exports["default"] = exports.audioFileTypes = exports.adobeAndRelatedFileTypes = void 0;
//Used https://github.com/jshttp/mime-db mime database for reference

var audioFileTypes = exports.audioFileTypes = {
  aac: ['audio/aac', 'audio/x-aac'],
  aif: ['audio/x-aiff'],
  aiff: ['audio/x-aiff'],
  m4a: ['audio/mp4', 'audio/x-m4a'],
  mid: ['audio/midi'],
  midi: ['audio/midi'],
  mp3: ['audio/mpeg'],
  ogg: ['audio/ogg'],
  wav: ['audio/wav', 'audio/wave', 'audio/x-wav'],
  weba: ['audio/webm'],
  wma: ['audio/x-ms-wma']
};
var videoFileTypes = exports.videoFileTypes = {
  avi: ['video/x-msvideo'],
  m4v: ['video/x-m4v'],
  mkv: ['video/x-matroska'],
  mov: ['video/quicktime'],
  mp4: ['video/mp4'],
  mpeg: ['video/mpeg'],
  mpg: ['video/mpeg'],
  mxf: ['application/mxf'],
  ogv: ['video/ogg'],
  webm: ['video/webm']
};
var domMountableImageFileTypes = exports.domMountableImageFileTypes = {
  avif: ['image/avif'],
  gif: ['image/gif'],
  jpg: ['image/jpeg'],
  jpeg: ['image/jpeg'],
  jfif: ['image/jpeg'],
  png: ['image/png'],
  svg: ['image/svg+xml'],
  webp: ['image/webp']
};
var uploadableImageFileTypes = exports.uploadableImageFileTypes = {
  bmp: ['image/bmp', 'image/x-ms-bmp'],
  dwg: ['image/vnd.dwg'],
  heic: ['image/heic', 'image/heic-sequence'],
  jp2: ['image/jp2'],
  tga: ['image/x-tga'],
  tif: ['image/tiff'],
  tiff: ['image/tiff']
};
var textFileTypes = exports.textFileTypes = {
  csv: ['text/csv'],
  htm: ['text/html'],
  log: ['text/plain'],
  rtf: ['application/rtf', 'text/rtf'],
  txt: ['text/plain']
};
var documentFileTypes = exports.documentFileTypes = {
  doc: ['application/msword'],
  docm: ['application/vnd.ms-word.document.macroenabled.12'],
  docx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  dotm: ['application/vnd.ms-word.template.macroenabled.12'],
  dotx: ['application/vnd.openxmlformats-officedocument.wordprocessingml.template'],
  key: ['application/vnd.apple.keynote', 'application/x-iwork-keynote-sffkey'],
  keynote: ['application/vnd.apple.keynote'],
  m3u8: ['application/vnd.apple.mpegurl'],
  mpp: ['application/vnd.ms-project'],
  msg: ['application/vnd.ms-outlook'],
  numbers: ['application/vnd.apple.numbers', 'application/x-iwork-numbers-sffnumbers'],
  odp: ['application/vnd.oasis.opendocument.presentation'],
  odt: ['application/vnd.oasis.opendocument.text'],
  pages: ['application/vnd.apple.pages', 'application/x-iwork-pages-sffpages'],
  pdf: ['application/pdf'],
  potx: ['application/vnd.openxmlformats-officedocument.presentationml.template'],
  ppt: ['application/vnd.ms-powerpoint'],
  pptm: ['application/vnd.ms-powerpoint.presentation.macroenabled.12'],
  pptx: ['application/vnd.openxmlformats-officedocument.presentationml.presentation'],
  ppsx: ['application/vnd.openxmlformats-officedocument.presentationml.slideshow'],
  xls: ['application/vnd.ms-excel'],
  xlsb: ['application/vnd.ms-excel.sheet.bindary.macroenabled.12'],
  xlsm: ['application/vnd.ms-excel.sheet.macroenabled.12'],
  xlsx: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
};
var adobeAndRelatedFileTypes = exports.adobeAndRelatedFileTypes = {
  ai: ['application/postscript'],
  eps: ['application/postscript'],
  ps: ['application/postscript'],
  psd: ['image/vnd.adobe.photoshop'],
  vwx: ['application/octet-stream', '']
};
var fontFileTypes = exports.fontFileTypes = {
  otf: ['font/otf'],
  ttf: ['font/ttf']
};
var fileTypes = Object.assign(audioFileTypes, videoFileTypes, domMountableImageFileTypes, uploadableImageFileTypes, textFileTypes, documentFileTypes, adobeAndRelatedFileTypes, fontFileTypes);
var _default = exports["default"] = fileTypes;